// permission.resolver.ts
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { filter, first, map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PermissionResolver implements Resolve<any> {
    constructor(private authService: AuthService) {}
    resolve(): Observable<any> {
        return this.authService.permission$.pipe(
            filter((p) => p && Object.keys(p).length > 0), // 👈 Logs the value
            first()
        );
    }
}
